import React,{useState,useEffect} from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import ForgotPasswords from "../../components/ForgotPassword";
import ChangePassword from "../../components/ChangePassword/ResetPassword";
import Footer from "../../components/Footer";
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import * as Axios from "../../services/auth";
import { Flip, Slide, toast } from 'react-toastify';

import './ResetPassword.styles.css';

const ResetPassword = () => {
	
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [token, setToken] = useState();
	const [email, setEmail] = useState();

	useEffect(async () => {
		if(searchParams.get("token")){
			const url = "accounts/validate-reset-token"
			const val = {
				token: searchParams.get("token"),
			}
			const response = await Axios.commonPost(val, url);	
			if (response && response.status === 200 && response.data.message=="Token is valid") {
				setToken(searchParams.get("token"));
				setEmail(searchParams.get("email"));
			}else{
				toast.error('Password Change token is not valid !', {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 3000,
					transition: Flip,
				});
				navigate('/');
			}
		}else{
			navigate('/');
		}
	  }, [searchParams])

	return (
		<div>
			<Helmet>
				<title>Forgot Password</title>
			</Helmet>
			<Header />
			<ChangePassword token={token} email={email}/>
			<Footer />
		</div>
	);
};

export default ResetPassword;